export class Error {
    errorName: string;
    errors: Array<string> = [];
    constructor(errorName, errors) {
        this.errorName = errorName;
        this.errors = errors;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/app/error.ts